<template>
	<main class="certificate">
		<div class="Linkus-top">
			<img
				:src="require('@/assets/images/linkus-top.png')"
				class="image-width"
				alt="linkusImage"
			/>
		</div>
		<van-tabs
			v-model="active"
			sticky
			color="#1630ED"
			title-active-color="#1630ED"
			:line-width="100"
			:ellipsis="false"
			lazy-render
		>
			<van-tab :title="$t('渠道商授权验证')"> </van-tab>
			<van-tab :title="$t('规格防伪查询')"> </van-tab>
		</van-tabs>
		<CertificateForm class="van-tabs" :type="type" :key="active" />
	</main>
</template>

<script>
import CertificateForm from './components/CertificateForm.vue';
export default {
	components: {
		CertificateForm
	},
	data() {
		return {
			active: 0
		};
	},
	computed: {
		type() {
			return this.active === 0 ? 'channel' : 'antiCounterfeiting';
		}
	}
};
</script>

<style lang="scss">
.van-tabs {
	padding: 20px 40px;
}

.van-tab {
	padding: 0 !important;
}
</style>
